module.exports = __webpack_public_path__ + "img/cave133.abff6d12.jpg";